import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const Preloader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full height of the viewport
        width: '100%',   // Full width
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Preloader;